module.exports = __webpack_public_path__ + "img/rankup_bar.15ce2cd9.svg";